/**
 * Scallop permitted vessels from 2025 NOAA permit data
 * Used to filter AIS data to show only actual scallop vessels
 * Total: 694 vessels with Limited Access or General Category scallop permits
 */

export const SCALLOP_PERMITTED_VESSELS = new Set([
  '2 SEA SONS', '25 TO LIFE', 'AARSHEIM JUNIOR', 'ABBIE & HOLLY', 'ABIGAIL ANN',
  'ADVENTURESS', 'ALANNA RENEE', 'ALASKA', 'ALEXANDRA L', 'ALEXANDRIA DAWN',
  'ALISHA J', 'ALL LYNN', 'ALL OUT', 'ALLIANCE', 'ALLISON', 'ALYSSA & ANDREW',
  'AMANDA ANN', 'AMANDA ASHLEY', 'AMANDA C', 'AMANDA MAY', 'AMASKA', 'AMBASSADOR',
  'AMBER NICOLE', 'AMBER WAVES', 'AMBITION', 'AMELIA JOYCE', 'AMERICA',
  'AMERICAN HERITAGE', 'AMERICAN PRIDE', 'AMERICAN VIKING', 'ANDREA A', 'ANDY TWO',
  'ANGELA & ROSE', 'ANN M', 'ANN MARIE', 'ANNIKA SCARLETT', 'ANOTHER NOTCH',
  'ANTICIPATION', 'ANTONIO JORGE', 'ANYA JO', 'ARAHO', 'ARCTURUS', 'ASHLEY GAIL',
  'ASHTON MATTHEW', 'ATLANTIC', 'ATLANTIC BOUNTY', 'ATLANTIC CAPES', 'ATLANTIC EXPLORER',
  'ATLANTIC GIRL', 'ATLANTIC PRINCE', 'ATLANTIC WARRIOR', 'AUSTIN C', 'AVA G',
  'AVENGER', 'BADA BING', 'BALD EAGLE II', 'BARBARA ANNE', 'BARBARA PAULINE',
  'BAY DRIFTER', 'BEACHCOMBER', 'BEAR', 'BEAST OF BURDEN', 'BEININGEN', 'BETH ANNE',
  'BIG BOB', 'BIG DIPPER', 'BIG DOG', 'BIRDIE P', 'BLACK SHEEP', 'BLACKBEARD',
  'BLUE HARVEST', 'BLUE LAGOON', 'BLUE OCEAN', 'BLUE SEA', 'BLUE STREAM',
  'BLUE WATER III', 'BODEN MICHAEL', 'BOOMER TOO', 'BOUNTIFUL', 'BOUNTIFUL II',
  'BRANDON JAY', 'BRIDGOT DENISE', 'BRITTANY ERYN', 'BROOKE C', 'BUCKEYE', 'BULLDOG',
  'CAITLIN CHRISTINE', 'CALHAM', 'CAMERON SCOTT', 'CAPT BOB', 'CAPT CARL', 'CAPT CECIL',
  'CAPT DANNY', 'CAPT DJ', 'CAPT GASTON', 'CAPT GAVIN', 'CAPT JESSE', 'CAPT JOE',
  'CAPT JOHN', 'CAPT MALC', 'CAPT POTTER', 'CAPT SIG', 'CAPT T', 'CAPT TRAVIS',
  "CAPT'N JAKE", "CAPT'N LEE", 'CAPTAIN BILLY HAVER', 'CAPTAIN LYMAN', 'CAPTN MARK',
  'CARL & CO', 'CARLEY GRACE', 'CAROL ANN', 'CAROL MARIE', 'CAROLINA BOY',
  'CAROLINA CAPES II', 'CAROLINA QUEEN III', 'CARPE DIEM', 'CASSIE C', 'CAT EYES',
  'CATHERINE ELIZABETH', 'CATHERINE LANE', 'CB KEANE', 'CELTIC', 'CHALLENGE',
  'CHANDLER RAE', 'CHARGER', 'CHARISMA', 'CHARLIES PRIDE', 'CHASE & BO',
  'CHASIN RAINBOWS', 'CHATHAM', 'CHAZS TOY', 'CHELSEA GIRL', 'CHELSEA LEE',
  'CHERYL ANN', 'CHIEF & CLYDE II', 'CHIX DIG IT', 'CHRISTI-CAROLINE',
  'CHRISTIAN & ALEXA', 'CHRISTINA MARIE', 'CHRISTY', 'CLEAN SWEEP', 'CODY',
  'COLETTE IVY', 'COLLIN & WARREN III', 'COLTEN SCOTT', 'CONCORDIA',
  'CONOR AND MICHAEL', 'CONTENDER', 'COOL CHANGE', 'COURAGEOUS', 'COVE',
  'CRYSTAL GIRL B', 'CYNBEL', 'DAMARISCOTTA', 'DARTH VADER', 'DAUNTLESS',
  'DEBBIE SUE', 'DEBRA ANN II', 'DECISIVE', 'DEFENDER', 'DETERMINATION',
  'DILIGENCE', 'DISCOVERY', 'DIVINE MERCY', 'DOLORES', 'DONNA JEAN II',
  'DONNA LYNN', 'DONNA MARIE', 'DONNY C', 'DOUBLE DOWN', 'DRAGON LADY', 'DYRSTEN',
  'E S S PRIDE', 'EAGLE-1', 'EARLY TIMES', 'EDGARTOWN', 'EL JEFE', 'ELEANOR J',
  'ELEANOR KATHRYN III', 'ELISE G', 'ELIZABETH', 'ELIZABETH & NIKI',
  'ELIZABETH KATHERINE', 'EMILY ANNE', 'EMMA & MARIA', 'ENDEAVOR', 'ENDEAVOUR',
  'ENDURANCE', 'ENTERPRISE', 'ERICA JADE', 'ESS PURSUIT', 'ESTRELA DOMAR',
  'EVA MARIE', 'EVENING STAR', 'EXCALIBUR', 'EXPECTATION', 'EXPLORER',
  'F NELSON BLOUNT', 'FEARLESS', 'FEATHER WHITE', 'FINLANDER II',
  'FIRST IMPRESSION II', 'FISH EYE', 'FISHERMAN', 'FISHERMANS DREAM B',
  'FISHERMANS PRIDE', 'FJORD', 'FLAVIAN S', 'FOOLS GOLD', 'FORTITUDE',
  'FORTUNE HUNTER', 'FOUR GIRLS', 'FRAID KNOT', 'FRANCIS M LEE SR', 'FREEDOM',
  'FRIENDSHIP', 'FRONTIER', 'FURIOUS', 'GABRIELLA ROSE', 'GALWAY', 'GANNET',
  'GASTONS LEGACY', 'GENERATION', 'GEORGES BANKS', 'GLUTTON', 'GODS MERCY',
  'GODZILLA', 'GOLDEN NUGGETT', 'GOOD NEWS II', 'GRACE', 'GRAND LARSON III',
  'GRAND SLAM', 'GREYHOUND', 'GRIN-N-BARRETT', 'GROWLER', 'GUARDIAN', 'GUIDANCE',
  'GULF STREAM', 'HADLEY RUTH', 'HAILEY DAWN', 'HALINA M', 'HANNAH RUTH',
  'HANNAH STORY', 'HARD TO HANDLE', 'HARVEST MOON', 'HARVESTER', 'HAWK',
  'HEATHER JOE', 'HEATHER LYNN', 'HELEN HAYES', 'HELEN LOUISE', 'HELLTOWN',
  'HERA', 'HERITAGE', 'HIGH ROLLER', 'HOLD FAST', 'HOPE & SYDNEY', 'HOPEFULL',
  'HORIZON', 'HOTATE', 'HUNTER', 'HUNTRESS', 'HUSTLER', 'IAN NIGEL', 'ILLUSION',
  'INCENTIVE', 'INDEPENDENCE', 'INHERITANCE', 'INSTIGATOR', 'INTERCEPTOR',
  'INTREPID', 'INVADER', 'INVICTUS', 'ISABEL & LILEE', 'ISABELLA & AVA',
  'ISLA & ALANEA', 'ISLA & GRAYSON', 'ITALIAN PRINCESS', 'IVY JEAN', 'JACK M',
  'JACOB AND JOSHUA', 'JAIME MAE', 'JAMES & MATTHEW', 'JANE CAROLYN',
  'JANE ELIZABETH', 'JAXON BELL', 'JEAN MARIE', 'JEFFREY SCOTT', 'JENNA LEE',
  'JENNIFER ANN', 'JENNY CAL', 'JERSEY BOYS', 'JERSEY CAPE', 'JERSEY DEVIL',
  'JERSEY GIRL', 'JERSEY PRIDE', 'JESSICA HEATHER', 'JILLIAN & PERI', 'JOANN B',
  'JOANNE A III', 'JOCKA', 'JOHN & NICHOLAS', 'JONATHAN RYAN', 'JOY FRANCES',
  'JOYCE D', 'JULIANNE', 'JULIE ANN', 'JUST FOR SPITE', 'JUSTICE', 'K A T E',
  'K A T E II', 'KAHUNA', 'KAILEY ERICA', 'KARAH D', 'KAREN ELIZABETH', 'KAREN L',
  'KAREN NICOLE', 'KATHRYN MARIE', 'KATHY ANN', 'KATHY MARIE', 'KATHY ROSE',
  'KATIE MAY', 'KAYLA ROSE', 'KELLY S', 'KELSI & MORGAN', 'KENNETH J DUNCAN',
  'KIM & JR II', 'KIM ANN II', 'KIMBERLY LYNN', 'KINEO', 'KINGFISHER', 'KODIAK',
  'KRISTEN S', 'KRISTINE MARIE', 'KYLER C', 'LADY ANNA', 'LADY BRITTANY',
  'LADY DEBORAH', 'LADY DEE', 'LADY ELAINE', 'LADY OF FATIMA', 'LADY PEARL SKIFF',
  'LADY ROSLYN', 'LADY SAMAIRA', 'LAKESIDE PREDATOR', 'LAURA MAE', 'LAURA WYNN',
  'LAUREN KIM', 'LAURIE ANN', 'LEADER', 'LEGACY', 'LENA PEARL', 'LIBERTY',
  'LIGHTNING BAY', 'LIGIA', "LIL' BROOKS", 'LILLY ROSE', 'LILY M', 'LIN MARIE',
  'LINDA KATE', 'LITTLE BIT', 'LITTLE SAMMIE', 'LITTLE TOOTIE', 'LONG FACES',
  'LONG HAUL', 'LORI ANN', 'LOST GENERATION II', 'LUCKY DANNY II', 'LUCKY THIRTEEN',
  'LUKE & GRACE', 'LUZITANO', 'LYNAM JACKSON', 'LYNDON JOHNSON', 'LYNN & WILLIAM',
  'M.F. HY-GRADER', 'MACKENZIE PAIGE II', 'MADELYN', 'MADI J', 'MADISON KATE',
  'MADISON ROSE', 'MAELSTROM', 'MAIZEY JAMES', 'MAJOR EXPENSE', 'MAMA TRIED',
  'MANFORD L PORTER', 'MARGARET HOLLEY', 'MARIA AND DOROTHY', 'MARIA NOELLE',
  'MARINER', 'MARISSA & JULIE', 'MARKET PRICE', 'MARTHA ROSE', 'MARY ANNE',
  'MARY ELIZABETH', 'MARY M', 'MARY MARGARET', 'MARY ROSE', 'MARY VEE',
  'MASTER JAMES', 'MAXED OUT', 'MCKENSIE LEE', 'MCKENZIE', 'MEKONG', 'MELISSA K',
  'MENEMSHA ROSE', 'MICAH BELL', 'MICHAEL BRANDON', 'MICHAEL JR', 'MICHELLE & LEXI',
  'MIDNIGHT OUR', 'MIDNIGHT SUN', 'MIRAGE', 'MISS ALLI', 'MISS AMANDA', 'MISS AMITY',
  'MISS ANITA', 'MISS CAROLINE', 'MISS CROCKETT', 'MISS EMILY', 'MISS EMMA',
  'MISS GEORGIE', 'MISS KELLY', 'MISS LESLIE', 'MISS LINDSEY', 'MISS MADDY',
  'MISS MADELINE', 'MISS MAUDE', 'MISS ROCKVILLE', 'MISS SABRAH', 'MISS SHAUNA',
  'MISS STEVIE B II', 'MISS TAMARA', 'MISS TAYLOR', 'MISS TYLER', 'MISTER G',
  'MISTY DAWN', 'MIZ ALMA B', 'MIZ JUANITA B', 'MONEY SHOT', 'MONICA TYMIN',
  'MONOMOY', 'MOTIVATION', 'MR. PETE', 'MS MANYA', 'MY BOYS', 'MY GIRL',
  'MY GIRLS II', 'MYSTIQUE LADY', 'NADIA LEE', 'NANCY ELIZABETH', 'NASHIRA',
  'NATALIE LYNN', 'NAUTILUS II', 'NAVIGATOR', 'NEGOTIATOR', 'NEMESIS', 'NESKONE',
  'NEWFIE STAR', 'NICHOLAS C', 'NICOLE DANIELLE', 'NICOLE JEAN', 'NICOLE LEIGH',
  'NIGHTMOVES', 'NISSA KAY', 'NO NAME', "NOBODY'S BUSINESS", 'NOELLA C',
  'NORDIC PRIDE', 'NORSEMAN', 'NORTH SEA', 'NORTH STAR', 'NORTHERN K',
  'NORTHERN LIGHTS', 'OCEAN BLUE', 'OCEAN BOY', 'OCEAN FOX', 'OCEAN HUNTER',
  'OCEAN LADY', 'OCEAN LEADER', 'OCEAN PRIDE', 'OCEAN PRINCESS', 'OCEAN PROWLER',
  'OCEAN QUEEN', 'OCEAN SCOUT', 'OCEAN STATE', 'OCEAN WAVE', 'OCEANIC', 'ODYSSEY',
  'OLIVIA CATHERINE', 'OLYMPIA', 'ORION', 'OUTLAW', 'OUTNUMBERED', 'OVERKILL',
  'PACER', 'PACIFICS', 'PADRE PIO', 'PAMELA ANN', 'PAPAS GIRL', 'PATCHES',
  'PATIENCE', 'PATRIARCH', 'PATRICIA ANN', 'PATRICIA M', 'PATRIOT', 'PATRIOTS',
  'PAUL & MICHELLE', 'PAULA LYN', 'PAULO MARC', 'PERCEPTION', "PERFECT C'S",
  'PILGRIM', 'POLAR CRAFT SKIFF', 'POLARIS', 'PREDATOR', 'PRETENDER', 'PRETTY GIRL',
  'PRETTY LADY', 'PRINCESS SCARLETT', 'PRIVATEER SKIFF', 'PROSPECTOR', 'PROUD MARY',
  'PROVIDENCE', 'PROVIDER', 'PROVIDER II', 'PROVIDER III', 'PROWESS', 'PROWLER',
  'PURSUIT', 'PYXIS', 'QUEEN OF PEACE', 'RACHEL HAILEY', 'RAELEEN MICHELLE',
  'RAIDERS', 'RANGER', 'RAYDA CHERAMIE', 'RAZZO', 'REDEMPTION', 'REGINAS PRIDE',
  'REGULUS', 'RELENTLESS', 'RELIANCE', 'RESILIENCE', 'RESILIENT', 'RESOLUTION',
  'RESOLVE', 'RETRIEVER', 'RHUMBOOGIE', 'RIANDA S', 'RIMRACK', 'ROBERT MICHAEL',
  'ROBERTA C', 'ROBERTA LEE', 'ROEN KEIL', 'ROLEX', 'ROSE & ZEUS II', 'ROSE BING',
  'ROSE MARIE', 'ROST', 'ROXI ELIZABETH', 'RUTHY L', 'RYLEE L', 'RYLEEFIN', 'SAGA',
  'SAINT JAMES', 'SAINTS & ANGELS', 'SALTED', 'SALTY DOG', 'SANDRA ANNE',
  'SANTA BARBARA', 'SANTA ISABEL', 'SANTA MARIA', 'SAO MARCOS II', 'SAO PAULO',
  'SARAH KELLEY', 'SASSY GIRL', 'SCOTT NATHAN', 'SEA DOG', 'SEA DUCED',
  'SEA FARMER II', 'SEA HAWK', 'SEA QUEST', 'SEA RANGER', 'SEA STAR',
  'SEA WATCHER I', 'SEA WOLF', 'SEAFARER', 'SEAFLASH', 'SECOND WIND', 'SEEL JR',
  'SELJE', 'SEVEN SEAS', 'SHARON K', 'SHARON NICOLE', 'SHEARWATER', 'SHEILA RENE',
  'SHELBY ANN', 'SHIRLEY KATE', 'SHIRLEY MARIE', 'SKYANNIRA', 'SLACKER',
  'SMALL STUFF', 'SMOKINBULL', 'SOCATEAN', "SOMETHIN' ELSE", 'SOPHIA C',
  'SORRY CHARLIE', 'SOUTHPAW', 'SS MELON III', 'STACY LEE', 'STARBRITE',
  'STARDUST', 'STARLIGHT', 'STELLA JANE', 'STURGEON', 'SUN DOG', 'SUNLIGHT',
  'SUSAN C', 'SUSAN ELIZABETH', 'SUSAN L', 'SUSAN LEIGH', 'SUSAN MARIE',
  'SUSAN MARIE II', 'SWAGGY B', 'TEMPTRESS', 'TENACIOUS', 'TERMINATOR II',
  'THE COUNT', 'THE GIPPER', 'THOR', 'THREE GRACES', 'THREE SONS', 'THUNDER BAY',
  'TIMBERLINE I', 'TINA', 'TINA LYNN', 'TINA MARIA', 'TITAN', 'TNT',
  'TOM SLAUGHTER II', 'TOMAHAWK', 'TONY TWO', 'TORBAY', 'TORNADO ALLEY',
  'TRADE WIND', 'TRADITION', 'TRICIA LYNN', 'TRIPLE THREAT', 'TRISHA MARIE',
  'TRITON', 'TRIUNFO', 'TROPICO', 'TWO ANNS', 'U-BOYS', 'UNITED STATES',
  'VANQUISH', 'VANTAGE', 'VAUD J', 'VELARIS', 'VENGEANCE', 'VENTURE', 'VICKIE II',
  'VICTORAY', 'VIGILANCE', 'VIKING', 'VIKING POWER', 'VIKING ROSE', 'VILA DO CONDE',
  'VINDICATOR', 'VIRGINIA CLIPPER', 'VIRGINIA DARE', 'VIRGINIA LYNN',
  'VIRGINIA MARISE', 'VIRGINIA QUEEN', 'VIRGINIA WAVE', 'WARRIOR', 'WEATHERLY',
  'WESLEY L', 'WESTERN EDGE', 'WESTPORT', 'WHITE CAP', 'WHITECAP',
  'WHITNEY & ASHLEY', 'WILLIAM & LAUREN', 'WILLIAM LEE', 'WILLIAM LYNN',
  'WINDSONG', 'WISDOM', 'WIZARD', 'WONDER WOMAN', 'WREAKING HAVOC', 'WYANDOT',
  'YANKEE PRIDE'
]);

/**
 * Check if a vessel name is a permitted scallop vessel
 * @param {string} vesselName - The vessel name to check
 * @returns {boolean} - True if the vessel has a scallop permit
 */
export const isScallopVessel = (vesselName) => {
  if (!vesselName) return false;
  return SCALLOP_PERMITTED_VESSELS.has(vesselName.toUpperCase().trim());
};

export default SCALLOP_PERMITTED_VESSELS;
